module.exports = __webpack_public_path__ + "static/media/28_tn.50468c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/28_tn.jpg
// module id = 242
// module chunks = 0